import { Component, OnInit } from '@angular/core';
import {finalize} from 'rxjs/operators';
import {ShoppingService} from '@app/shopping/shopping.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ModalDismissReasons, NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import {ShoppingModel} from '../../models/shopping.model';
import {ShoppingPromotionModel} from '../../models/shopping-promotion.model';
import {NfModel} from '../../models/nf.model';
import {NfCampaignModel} from '../../models/nf-campaign.model';
import {NfResumeModel} from '../../models/nf-resume.model';
import {PlaceServiceBase} from '@app/core/places.service';
import {ChainService} from '@app/chain/chain.service';
import {DomainService} from '@app/core/domain/domain.service';

@Component({
  selector: 'app-shopping-promotion',
  templateUrl: './shopping-promotion.component.html',
  styleUrls: ['./shopping-promotion.component.scss']
})
export class ShoppingPromotionComponent {
  listNf: NfCampaignModel[] = [];
  nfResult: any = {};
  nfResume: NfResumeModel = new NfResumeModel();
  promotion: ShoppingPromotionModel;
  shoppingid: string;
  promotionId: string;
  modalReference: NgbModalRef;
  currentContent: any;

  qtdCoupons = 0;
  qtdScratchs = 0;

  placeService: PlaceServiceBase;
  isShoppingDomain: boolean;

  constructor(
    private shoppingService: ShoppingService,
    private chainService: ChainService,
    private domainService: DomainService,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal
  ) {
    this.isShoppingDomain = domainService.isShoppingDomain();
    this.placeService = this.isShoppingDomain ? shoppingService : chainService;

    this.route.params.subscribe( params => {
      this.promotionId = params.promotionId;
      this.loadShoppingPromotion(this.promotionId);
      this.shoppingid = params.shoppingId;
    } );
  }

  ngOnInit() {
    this.getResumeNf(this.promotionId);
  }

  loadShoppingPromotion(promotionId: string) {
    this.placeService.getPromotion(promotionId)
      .pipe(finalize(() => {
      }))
      .subscribe(promotions => {
        this.promotion = promotions;
      }, error => {
        console.log(`shopping error: ${error}`);
      });
  }


  getResumeNf(promotionId: string) {
    this.placeService.getResumeNf(promotionId)
      .pipe(finalize(() => {
      }))
      .subscribe(resume => {
        this.nfResume = resume;
        this.listNf = this.nfResume.resumeCampaing.details;
      }, error => {
        console.log(`List NF error: ${error}`);
      });
  }

  isChangeAvaible(): boolean {

    if (this.nfResume && this.nfResume.resumeCampaing &&
      (this.nfResume.resumeCampaing.balance >=
        this.nfResume.resumeCampaing.averageTicket) ) {
      return true;
    }
    return false;
  }

  redeemCoupons(promotionId: string, content: any) {
    this.currentContent = content;
    this.placeService.redeemCoupons(promotionId)
      .pipe(finalize(() => {
      }))
      .subscribe(resp => {
        this.nfResult = resp;
        if (this.nfResult && !this.nfResult.status) {
          this.qtdCoupons = this.nfResult.resumeReedemNF.coupons.length;
          this.qtdScratchs = this.nfResult.resumeReedemNF.scratchs.length;
          this.openModal(this.currentContent);
        }

      }, error => {
        console.log(`Redeem Coupons  error: ${error}`);
      });
  }

  openNf() {
    this.router.navigate(['/shopping/[shoppingId]/promotion/[promotionId]/nf'
      .replace('[shoppingId]', this.shoppingid)
      .replace('[promotionId]', this.promotion.id_hash)
    ]);
  }

  openModal(content: any) {
    this.closeModal();
    this.modalReference = this.modalService.open(content, { windowClass: 'modal-centered modal-md' });
  }

  finish() {
    this.closeModal();
    this.router.navigate(['/shopping/[shoppingId]/promotions'
      .replace('[shoppingId]', this.shoppingid)
    ]);
  }

  closeModal() {
    if (this.modalReference) {
      this.modalReference.dismiss();
    }

  }

}



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/shopping-promotion/shopping-promotion.component.ts